import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/pages/LegalPage.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/node_modules/next/dist/client/link.js");
